import { Outlet } from 'react-router';
import Footer from '@/components/Footer';
import LandingHeader from '@/components/Landing/Header';

function StaticLayout() {
  return (
    <div className='flex flex-col justify-between h-screen bg-white'>
      <LandingHeader />
      <Outlet />
      <Footer />
    </div>
  );
}

export default StaticLayout;
